const messages = {
  bonus: {
    title: "Przegląd bonusów",
    description: "Bonusy w euro są przyznawane uczestniczącym firmom na podstawie przesłanych danych sprzedażowych.",
    lastMonth: "Poprzedni miesiąc",
    currentMonth: "Bieżący miesiąc",
    totalCurrentYear: "Suma bieżącego roku",
    totalLastYear: "Suma poprzedniego roku",
  },
  points: {
    title: "Przegląd punktów",
    period: "Bieżący rok kalendarzowy ({year})",
    totalAwarded: "Łącznie przyznane punkty",
    redeemed: "Wykorzystane punkty",
    totalBalance: "Łączne saldo punktów",
    redemptionRate: "Wykorzystane punkty jako procent przyznanych punktów",
    averageAwarded: "Średnia liczba przyznanych punktów na kupioną oponę",
    standardAwarded: "Punkty netto z obliczonych linii sprzedaży, łącznie ze zwrotami",
    bsPlusInclBooster: "Punkty z linii sprzedaży o dodatniej ilości",
    perTire: "Wykorzystane punkty na kupioną oponę",
  },
  tires: {
    title: "Przegląd ilości opon",
    description: "Opony zakupione przez klientów",
    prevMonth: "Poprzedni miesiąc",
    totalLastYear: "Suma poprzedniego roku",
    purchaseIndirect: "Zakup przez hurtownika (pośredni)",
    purchaseDirect: "Zakup przez hurtownika (bezpośredni)",
    totalCurrentYear: "Suma bieżącego roku",
    currentMonth: "Bieżący miesiąc",
  },
  participating: {
    title: "Przegląd uczestniczących klientów",
    description: "Firmy rejestrujące się w BRIDGESTONE PLUS mogą zostać przypisane przez nas na podstawie numeru klienta.",
    total: "Łącznie",
    newThisMonth: "Nowi w tym miesiącu",
    newThisYear: "Nowi w tym roku",
    createdInCurrentMonth: "Utworzone w bieżącym miesiącu (przez administratora)",
    loginsCurrentYear: "Logowania w bieżącym roku (po akceptacji warunków)",
  },
  brand: {
    title: "Marka",
    description: "Twoje zakupy w szczegółach",
    centerTitle: "Według\nmarki",
  },
  rim: {
    title: "Felga",
    centerTitle: "Według rozmiaru\nfelgi",
  },
  tireGoals: {
    title: "Cele sprzedaży opon",
    subtitle: "Zdobywaj punkty za zakupy opon.",
    centerTitle: "Według rozmiaru\nopony",
    tiresRemaining: "Pozostałe opony",
    progressionTarget: "Cel postępu: ",
    pointsEarnedPurchases: "punkty zdobyte\n" + "za Twoje\n" + "zakupy",
    pointsEarnedBoosters: "punkty zdobyte\n" + "z\n" + "boosterów",
    purchasesDetail: "Twoje zakupy w szczegółach",
    cta: "Dowiedz się więcej o swoich punktach",
    pointsTitle: "Twoje punkty",
    pointsSubtitle: "Punkty zdobyte za zakupy Bridgestone",
    achievementsTitle: "Twoje osiągnięcia",
    achievementsSubtitle: "Twoje roczne zobowiązanie:",
    achievementsSubtitle2: "opon",
  },
  score: {
    title: "Wynik",
    total: "Łącznie",
    credits: "Uznania",
    deductions: "Odliczenia",
        unlockedPoints: "Odblokowane punkty",
        pendingPoints: "Oczekujące punkty",
  },
  score_extended: {
    title1: "Saldo punktów",
    title2: "Bonus w euro",
    balance: "Saldo punktów",
    bonus_in_euro: "Bonus w euro",
    date: "Data",
    added_points: "Dodane punkty",
    total_bands: "Łącznie marek",
    goal: "Cel",
    tyres_previous_year: "Opony sprzedane w poprzednim roku",
    tyres_current_year: "Opony sprzedane w tym roku",
    target_this_year: "Cel sprzedażowy na ten rok",
    bonus_this_year: "Wypracowany bonus (€)",
    loyal_minimum: "Minimalny poziom lojalności",
    bonus_multiplier: "Współczynnik bonusu",
  },
  lastImport: {
    label: "Ostatni import danych sprzedażowych:",
    on: "",
  },
  wholesalerTable: {
    title: "Szczegóły uczestniczących klientów",
    description: "Poniżej znajdziesz firmy, które zarejestrowały się w BRIDGESTONE PLUS przy użyciu numeru klienta Twojej firmy. Możesz użyć filtrów do innego sortowania lub wyszukiwarki, aby odnaleźć klientów.",
    columns: {
      customer_number: "Nr klienta",
      address_company_name: "Firma",
      address_street: "Ulica i numer",
      address_postal_code: "Kod pocztowy",
      address_city: "Miasto",
      last_registration: "Ostatnia rejestracja",
      network: "Sieć",
      profile_group: "Grupa",
      tires_amount: "Liczba opon",
      point_balance: "Saldo punktów",
      bonus: "Bonus",
      details: "Szczegóły",
    },
    searchPlaceholder: "Szukaj",
  },
  dealerTable: {
    columns: {
      date: "Data",
      wholesaler_bs_plus: "Hurtownik BS+",
      customer_number: "Numer klienta",
      article: "Artykuł",
      brand: "Marka",
      product: "Produkt",
      type: "Typ",
      inch: "Cal",
      season: "Sezon",
      amount: "Ilość",
      points: "Punkty",
      activity: "Aktywność",
      total_points: "Suma punktów",
    },
    title: "Tabela dealerów",
    description: "Przegląd aktywności dealerów",
  },
  business_units: {
    title: "Jednostki biznesowe",
    centerTitle: "Według\njednostki",
  },
  season: {
    title: "Sezon",
    centerTitle: "Według pory\nroku",
  },
};

export default {
  messages,
};
